module.exports = __webpack_public_path__ + "static/tiempo-outro-a10baf5e54be16bbf0a1dc19718db0e4.mp4";